import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@quintoandar-tokko/jopijs';
import styles from './filterBar.module.scss';
import AgentsDropdown from './dropdowns/AgentsDropdown';
import SelectionTags from './SelectionsTags/SelectionTags';
import BranchesDropdown from './dropdowns/BranchesDropdown';
import TeamsDropdown from './dropdowns/TeamsDropdown';
import TagsDropdown from './dropdowns/TagsDropdown';
import RangeDateDropdown from './dropdowns/RangeDateDropdown';
import UpdatedDropdown from './dropdowns/UpdatedDropdown';
import { getCompanyBranches } from '@/store/slices/components/filterBar/service';
import { FilterSelectionProvider } from './FilterSelectControl';

function FilterBar({
  showSelectionTags = true,
  selectionTagsItems,
  showTags,
  showRangeDate,
  showUpdatedFilter = false,
  extraContent = null,
  showAgentsfilter = true,
  showBranchesfilter = true,
  showTeamsfilter = false,
  showClearFilters = true,
  deleteRangeDate = true,
  highlightSelection = false,
  hugControls = false,
}) {
  const dispatch = useDispatch();
  const { selectedIds, selectBranches } = useSelector(
    (state) => state.FilterBarSlice.filters
  );

  // Fetched here (instead of inside BranchesDropdown) so the branch count is
  // known even when the dropdown itself is hidden by `hasMultipleBranches`.
  useEffect(() => {
    if (!showBranchesfilter) return;
    dispatch(getCompanyBranches());
  }, [dispatch, showBranchesfilter]);

  // A single branch means there's nothing to filter by, so the dropdown is hidden.
  const hasMultipleBranches = selectBranches.length > 1;

  return (
    <Box
      className={`${styles.filterBarContainer} ${
        hugControls ? styles.hugControls : ''
      }`}
    >
      <FilterSelectionProvider enabled={highlightSelection}>
        <Box className={styles.filterLeftContent}>
          {extraContent}
          {showBranchesfilter && hasMultipleBranches && <BranchesDropdown />}
          {showTeamsfilter && <TeamsDropdown />}
          {showAgentsfilter && <AgentsDropdown />}
          {showTags && <TagsDropdown />}
          {showRangeDate && (
            <RangeDateDropdown deleteRangeDate={deleteRangeDate} />
          )}
          {showUpdatedFilter && <UpdatedDropdown />}
        </Box>
      </FilterSelectionProvider>

      <Box className={styles.filterRightContent}>
        {(selectionTagsItems ?? selectedIds).length > 0 &&
          showSelectionTags && (
            <SelectionTags
              showClearFilters={showClearFilters}
              items={selectionTagsItems}
            />
          )}
      </Box>
    </Box>
  );
}

export default FilterBar;
